









































import { Vue, Component } from 'vue-property-decorator';
import { Cell, CellGroup, Icon, Toast, Popup } from 'vant';
import { voteList, vote } from '../api';
import VoteButton from '../components/VoteButton.vue';
Vue.use(Cell);
Vue.use(CellGroup)
  .use(Icon)
  .use(Toast)
  .use(Popup);
@Component({
  components: {
    VoteButton,
  },
})
export default class Home extends Vue {
  list: any[] = [];
  newVotes = '';
  show = false;
  content = {};
  async created() {
    const res: any = await voteList();
    if (res.code === 200) {
      this.list = res.data;
    } else {
      Toast(res.msg);
    }
  }
  showModel(e: any) {
    console.log('showModel', e);
    this.content = e.content;
    this.show = !this.show;
  }
  votSuccess(res: any) {
    console.log('object', res);
    this.list.forEach((item: any) => {
      if (item.id === res.voteId) {
        item.votes++;
      }
    });
  }
}
